import React from "react";
import { useCounter } from "../../hooks/useCounter";

export const AnimatedNumber = ({ value, suffix = "", duration = 2000 }) => {
  const numericValue = parseFloat(value.toString().replace(/[^0-9.]/g, ""));
  const { count, ref } = useCounter(numericValue, duration);

  const formatNumber = (num) => {
    if (value.toString().includes("M")) return `${num}M`;
    if (value.toString().includes("K")) return `${num}K`;
    if (value.toString().includes("%")) return `${num}%`;
    return num.toString();
  };

  return <span ref={ref}>{formatNumber(count)}{suffix}</span>;
};